import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/DragNDrop/DragLayer.tsx";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.timers.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React from 'react';
import { useDragLayer } from 'react-dnd';
import { DndType } from "./dndType";
import { DragLayerText } from "./DragLayer.styled";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var layerStyles = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 1000000,
  left: 0,
  top: 0,
  width: '100%',
  height: '100%'
};
export function snapToGrid(x, y) {
  var snappedX = Math.round(x / 32) * 32;
  var snappedY = Math.round(y / 32) * 32;
  return [snappedX, snappedY];
}

function getItemStyles(initialOffset, currentOffset, isSnapToGrid) {
  if (!initialOffset || !currentOffset) {
    return {
      display: 'none'
    };
  }

  var x = currentOffset.x,
      y = currentOffset.y;

  if (isSnapToGrid) {
    x -= initialOffset.x;
    y -= initialOffset.y;

    var _snapToGrid = snapToGrid(x, y);

    var _snapToGrid2 = _slicedToArray(_snapToGrid, 2);

    x = _snapToGrid2[0];
    y = _snapToGrid2[1];
    x += initialOffset.x;
    y += initialOffset.y;
  }

  var transform = "translate(".concat(x, "px, ").concat(y, "px)");
  return {
    transform: transform,
    WebkitTransform: transform,
    background: '#fff',
    width: '250px',
    padding: '15px',
    height: '34px',
    borderRadius: '5px',
    display: 'flex',
    alignItems: 'center',
    boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.25)',
    whiteSpace: 'nowrap'
  };
}

export var DRAG_BEGIN_DELAY = 100; // const dependenciesCheckedCount$ = dependenciesCheckedModel.count$

export var DragLayer = /*#__PURE__*/React.memo(function (_ref) {
  var editorCheckedCount = _ref.editorCheckedCount,
      depsCheckedCount = _ref.depsCheckedCount;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      showLayer = _React$useState2[0],
      setShowLayer = _React$useState2[1];

  var _useDragLayer = useDragLayer(function (monitor) {
    return {
      initialOffset: monitor.getInitialSourceClientOffset(),
      currentOffset: monitor.getClientOffset(),
      isDragging: monitor.isDragging(),
      itemType: monitor.getItemType()
    };
  }),
      initialOffset = _useDragLayer.initialOffset,
      currentOffset = _useDragLayer.currentOffset,
      isDragging = _useDragLayer.isDragging,
      itemType = _useDragLayer.itemType;

  React.useEffect(function () {
    if (!showLayer && isDragging) {
      var timerId = setTimeout(function () {
        setShowLayer(true);
      }, DRAG_BEGIN_DELAY);
      return function () {
        return clearTimeout(timerId);
      };
    }
  }, [isDragging, showLayer]);
  React.useEffect(function () {
    if (!isDragging) {
      setShowLayer(false);
    }
  }, [isDragging]);

  if (!showLayer) {
    return null;
  }

  var count;

  switch (itemType) {
    case DndType.FROM_DEPENDENCIES:
      count = depsCheckedCount;
      break;

    case DndType.FROM_OWN_CLASSIFIER:
      count = editorCheckedCount;
      break;

    default:
      return null;
  }

  return /*#__PURE__*/_jsx("div", {
    style: layerStyles,
    children: /*#__PURE__*/_jsx("div", {
      style: getItemStyles(initialOffset, currentOffset, false),
      children: /*#__PURE__*/_jsxs(DragLayerText, {
        children: ["\u041F\u0435\u0440\u0435\u043C\u0435\u0441\u0442\u0438\u0442\u044C \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B (", count, "\u0448\u0442.)"]
      })
    })
  });
});
DragLayer.displayName = 'DragLayer';